import React from 'react';
import { PageComponent } from './ComponentLibrary';
import FAQ from '../FAQ';
import Newsletter from '../Newsletter';
import BankComparison from '../BankComparison';
import PreferredBanks from '../PreferredBanks';
import { Eye, Menu, Layout } from 'lucide-react';

interface ComponentPreviewProps {
  component: PageComponent;
}

const ComponentPreview: React.FC<ComponentPreviewProps> = ({ component }) => {
  // Render a preview based on component type
  const renderPreview = () => {
    switch (component.type) {
      case 'header':
        return (
          <div className="bg-slate-100 p-6 rounded-lg text-center">
            <Menu size={24} className="text-slate-400 mx-auto mb-2" />
            <p className="text-slate-600">Header Bileşeni</p>
            <p className="text-xs text-slate-500 mt-2">
              Logo: {component.settings?.logoText || 'KREDİPARK'}
              {component.settings?.isSticky ? ' (Sabit)' : ''}
            </p>
            <div className="mt-2 flex flex-wrap gap-2 justify-center">
              {(component.content?.menuItems || []).map((item: any, index: number) => (
                <span key={index} className="text-xs bg-slate-200 px-2 py-1 rounded">
                  {item.label || `Menü ${index + 1}`}
                  {item.isDropdown && <span className="ml-1">▼</span>}
                </span>
              ))}
            </div>
          </div>
        );
      case 'footer':
        return (
          <div className="bg-slate-100 p-6 rounded-lg text-center">
            <Layout size={24} className="text-slate-400 mx-auto mb-2" />
            <p className="text-slate-600">Footer Bileşeni</p>
            <p className="text-xs text-slate-500 mt-2">
              {component.content?.columns?.length || 0} sütun, 
              {component.content?.social ? ' Sosyal medya linkleri,' : ''} 
              İletişim bilgileri
            </p>
            <p className="text-xs text-slate-500 mt-1">
              {component.content?.copyrightText || `© ${new Date().getFullYear()} KrediPark. Tüm hakları saklıdır.`}
            </p>
          </div>
        );
      case 'faq':
        return (
          <div className="scale-[0.8] origin-top-left">
            <FAQ 
              customFaqs={component.content?.faqs || []} 
            />
          </div>
        );
      case 'newsletter':
        return (
          <div className="scale-[0.5] origin-top-left -ml-[25%] -mr-[25%] -mb-[25%]">
            <Newsletter />
          </div>
        );
      case 'bankComparison':
        return (
          <div className="scale-[0.6] origin-top-left -ml-[20%] -mr-[20%] -mb-[20%]">
            <BankComparison />
          </div>
        );
      case 'bankList':
        return (
          <div className="scale-[0.8] origin-top-left">
            <PreferredBanks />
          </div>
        );
      case 'textBlock':
        return (
          <div className="prose prose-slate max-w-none" dangerouslySetInnerHTML={{ __html: component.content?.text || '<p>Metin içeriği</p>' }} />
        );
      case 'imageBlock':
        return (
          <div className="space-y-2">
            <img 
              src={component.content?.imageUrl || 'https://images.unsplash.com/photo-1579621970795-87facc2f976d?auto=format&fit=crop&q=80&w=1200&h=600'} 
              alt={component.content?.caption || 'Görsel'} 
              className="w-full h-auto rounded-lg"
            />
            {component.settings?.showCaption && (
              <p className="text-sm text-slate-500 text-center">{component.content?.caption || 'Görsel açıklaması'}</p>
            )}
          </div>
        );
      case 'callToAction':
        return (
          <div className="bg-slate-100 p-6 rounded-lg text-center space-y-4">
            <h3 className="text-xl font-bold text-slate-800">{component.content?.heading || 'Aksiyon Çağrısı'}</h3>
            <p className="text-slate-600">{component.content?.description || 'Kısa açıklama metni'}</p>
            <button 
              className="px-6 py-2 bg-[#F7BA45] text-slate-900 rounded-lg font-medium"
              style={{ backgroundColor: component.settings?.buttonColor || '#F7BA45' }}
            >
              {component.settings?.buttonText || 'Hemen Başvur'}
            </button>
          </div>
        );
      default:
        return (
          <div className="bg-slate-100 p-6 rounded-lg text-center">
            <Eye size={24} className="text-slate-400 mx-auto mb-2" />
            <p className="text-slate-600">Bu bileşen türü için önizleme kullanılamıyor</p>
          </div>
        );
    }
  };
  
  return (
    <div className="overflow-hidden">
      {renderPreview()}
    </div>
  );
};

export default ComponentPreview;